module.exports = __webpack_public_path__ + "media/images/icons/filled/hdd-555f9d983eb2c7f552580641cb7bbbb0.svg";